import React, { useEffect, useState } from 'react'

type InputProps = {
    // onChange: Function;
    branches: any[];
    setFilterReferrer: Function;
}

const StationReferenceSelect = (props: InputProps) => {

    const [branches, setBranches] = useState<any[] | null>(null);

    const [projects, setProjects] = useState<any[]>([]);
    const [subBranches, setSubBranches] = useState<any[] | null>(null);
    const [stationUsers, setStationUsers] = useState<any[] | null>(null);


    const [projectName, setProjectName] = useState<string | undefined>(undefined);
    const [subBranchName, setSubBranchName] = useState<string | undefined>(undefined);
    const [stationUserName, setStationUserName] = useState<string | undefined>(undefined);


    


    const onProjectChange = (e: any) => {
        console.log('e.target.value', e.target.value)
        setProjectName(e.target.value);
        if (projects) {
            const selectedBranch = projects.find((b: any) => b.name == e.target.value && b.parentId===null);

            if (selectedBranch) {
                console.log('selectedBranch', selectedBranch)
                setSubBranches(selectedBranch.children);
                props.setFilterReferrer(selectedBranch.id);

            }
        }
        // props.onChange({ projectName: e.target.value });
    }

    const onSubBranchChange = (e: any) => {
        console.log('e.target.value', e.target.value)
        if(subBranches){
            const selectedBranch = subBranches.find((b: any) => b.name == e.target.value);
            console.log('selectedBranch', selectedBranch)
            setSubBranchName(e.target.value);
            if (selectedBranch) {
                const children = selectedBranch.children;
                if(children.length > 0){
                    setStationUsers(children);
                }
                props.setFilterReferrer(selectedBranch.id);
            }
            
        }
        // setSubBranchName(e.target.value);
        // props.onChange({ subBranchName: e.target.value });
    }

    const onStationUserChange = (e: any) => {
        console.log('e.target.value', e.target.value)

        if(stationUsers){
            const selectedBranch = stationUsers.find((b: any) => b.name == e.target.value);
            if(selectedBranch){
                setStationUserName(e.target.value);
                props.setFilterReferrer(selectedBranch.id);
            }
        }
        // setStationUserName(e.target.value);
        // props.onChange({ stationUserName: e.target.value });
    }

    const clearSubBranchName = () => {
        setSubBranchName('');
        setStationUserName('');
        setStationUsers([]);
        props.setFilterReferrer(undefined);
    }

    const clearProjectName = () => {
        setProjectName('');
        setSubBranchName('');
        setStationUserName('');
        setSubBranches([]);
        setStationUsers([]);
        props.setFilterReferrer(undefined);
    }

    

    useEffect(() => {
        console.log('branches useEffect', branches)
        if (props.branches && props.branches.length > 0) {
            const rootBranches = props.branches.filter((b: any)=>b.parentId===null && b.children.length > 0)
            setProjects(rootBranches);

            // let subBranchesList: any[] = [];
            // rootBranches.forEach((branch: any) => {
            //     const children = getSubBranches(branch);
            //     subBranchesList = [...subBranchesList, ...children];
            // });
            // setSubBranches(subBranchesList);

            // let stationUsersList: any[] = [];
            // subBranchesList.forEach((branch: any) => {
            //     const children = getSubBranches(branch);
            //     stationUsersList = [...stationUsersList, ...children];
            // });
            // setStationUsers(stationUsersList);
        }

    }, []);

    
    return (
        <>
            <div className="filter-input">
                <input type='text'
                    list="referer-projects_list"
                    placeholder='פרוייקט מפנה'
                    onChange={(e: any) => onProjectChange(e)}
                    value={projectName}
                />
                <datalist id="referer-projects_list">
                    {projects.map((o: any, i) => <option key={i} value={o.name}>{o.name}</option>)}
                </datalist>
                <div className={`icon x-clear pointer ${projectName === undefined || projectName === '' ? 'hide' : ''}`} onClick={clearProjectName}></div>

            </div>
            <div className="filter-input">
                <input type='text'
                    list="referer-subBranches_list"
                    placeholder='סניף מפנה'
                    onChange={(e: any) => onSubBranchChange(e)}
                    value={subBranchName}
                />
                <datalist id="referer-subBranches_list">
                    {subBranches && subBranches.map((o: any, i) => <option key={i} value={o.name}>{o.name}</option>)}
                </datalist>
                <div className={`icon x-clear pointer ${subBranchName === undefined || subBranchName === '' ? 'hide' : ''}`} onClick={clearSubBranchName}></div>
            </div>
            <div className="filter-input">
                <input type='text'
                    list="referer-stationUsers_list"
                    placeholder='מחלקה מפנה'
                    onChange={(e: any) => onStationUserChange(e)}
                    value={stationUserName}
                />
                <datalist id="referer-stationUsers_list">
                    {stationUsers && stationUsers.map((o: any, i) => <option key={i} value={o.name}>{o.name}</option>)}
                </datalist>
                {/* <div className={`icon x-clear pointer ${stationUserName === undefined || stationUserName === '' ? 'hide' : ''}`} onClick={clearStationUserName}></div> */}
            </div>
        </>

    )
}

export default StationReferenceSelect